// extracted by mini-css-extract-plugin
export default {"judges-homepage-detail-box":"index_judges-homepage-detail-box__vt62j"};